import type { ComputedRef, Ref } from 'vue';
import { usePrimeVue } from 'primevue/config';
import { computed } from 'vue';

import { useDevice } from '@modules/core/composables/device';

export interface ReportsMediaComposable {
  isGreaterThenMd: Ref<boolean>;
  selectLabel: ComputedRef<string | undefined>;
}
export default function useReportsMedia(): ReportsMediaComposable {
  const primevue = usePrimeVue();
  const isGreaterThenMd = useDevice().breakpoints.md;

  const selectLabel = computed(() => primevue.config.locale?.choose);

  return {
    isGreaterThenMd,
    selectLabel,
  };
}
